export enum UserLevelFlag {
  Head = "HEAD",
  Sub = "SUB",
  Individual = "INDIVIDUAL",
}

export interface UserLevel {
  id: number;
  name: string;
  flag: UserLevelFlag;
}

export enum UserType {
  ACCOUNT = "ACCOUNT",
  COST_CENTRE = "COST_CENTRE",
}

export enum UserLevelsEnum {
  Account = "ACCOUNT",
  SubAccount = "SUB_ACCOUNT",
}

export const userLevelLabels: { [key in UserLevelsEnum]: string } = {
  [UserLevelsEnum.Account]: "Account",
  [UserLevelsEnum.SubAccount]: "Sub Account",
};
